/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_PreferencesInputs */

const en_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences`)
};

const de_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const fr_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préférences`)
};

const es_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias`)
};

const it_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferenze`)
};

const nl_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorkeuren`)
};

const pl_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencje`)
};

const fi_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asetukset`)
};

const da_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Præferencer`)
};

const sv_settings_section_preferences = /** @type {(inputs: Settings_Section_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inställningar`)
};

/**
* | output |
* | --- |
* | "Preferences" |
*
* @param {Settings_Section_PreferencesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_section_preferences = /** @type {((inputs?: Settings_Section_PreferencesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_PreferencesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_section_preferences(inputs)
	if (locale === "fr") return fr_settings_section_preferences(inputs)
	if (locale === "es") return es_settings_section_preferences(inputs)
	if (locale === "it") return it_settings_section_preferences(inputs)
	if (locale === "nl") return nl_settings_section_preferences(inputs)
	if (locale === "pl") return pl_settings_section_preferences(inputs)
	if (locale === "fi") return fi_settings_section_preferences(inputs)
	if (locale === "da") return da_settings_section_preferences(inputs)
	if (locale === "sv") return sv_settings_section_preferences(inputs)
	return en_settings_section_preferences(inputs)
});